/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

:host {
  scroll-snap-align: start;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.web {
  display: flex;
  flex-direction: column;
}
